import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { observer } from "mobx-react";
import * as React from "react";
import {
  Action,
  FlexTrackingInfo,
  sendImmediateClickstreamTrackEvent,
} from "src/components/utility/analytics/FlexAnalyticsUtils";
import { withStores } from "src/stores";
import withImmediatelyFilteringExperiment, { ImmediateFilteringProps } from "../../ImmediatelyFilteringExperiment";
import { PROPERTY_FILTERS } from "../../PropertyFilters";
import { ExpandoPropertyFilters } from "./expando";
import { SimplePropertyFilters } from "./simple";
import { DesktopPropertyFiltersStores } from "./types";

interface DesktopPropertyFiltersWrapperProps extends ImmediateFilteringProps, DesktopPropertyFiltersStores {}

export const DesktopPropertyFilters = withImmediatelyFilteringExperiment(
  withStores(
    "context",
    "hotels",
    "propertyFilters"
  )(
    observer((props: DesktopPropertyFiltersWrapperProps) => {
      const { isImmediateFilteringEnabled, propertyFilters, hotels, context } = props;

      const track = useClickTracker();

      const apply = (rfrr: string): void => {
        const numberOffiltersApplied = propertyFilters.getNumberOfSelectedFilters();

        const flexTracking: FlexTrackingInfo = {
          moduleName: PROPERTY_FILTERS,
          rfrr: `${rfrr}.${numberOffiltersApplied}`,
          action: Action.CLICK,
        };

        sendImmediateClickstreamTrackEvent(flexTracking, track);
        propertyFilters.applyFilters(hotels, context, isImmediateFilteringEnabled);
      };

      if (isImmediateFilteringEnabled) {
        return <SimplePropertyFilters apply={apply} />;
      } else {
        return <ExpandoPropertyFilters apply={apply} />;
      }
    })
  )
);

export default DesktopPropertyFilters;
